import React from 'react'
import './customSelect.css'

const CustomSelect = (props) => {
  const { options, placeholder, change, error } = props;
  let { keyText } = props;
  if(!keyText || keyText === '') keyText = 'text'
  const onChange = (e) => change(options.filter(f => f[keyText].toString() === e.target.value).reduce((pre,cur) => cur, {}))
  return (
    <div className={(error) ? 'kml-container-input border-error-color' : 'kml-container-input'}>
      <select className="select" onChange={onChange}>
        <option value="#" disabled={true} selected={true} >{placeholder}</option>
        {
          options.map((o, i) => <option value={o[keyText]} key={`key-option-custom-select-${i}`} >{o[keyText]}</option>)
        }
      </select>
    </div>
  )
}

export default CustomSelect;